import apiClient from '../apiClient';
import { GET_RESTAURANT_TYPE_URL } from '../apiUrl';

const getRestaurantTypeApi = () => {
  return apiClient.get(GET_RESTAURANT_TYPE_URL);
};

export default getRestaurantTypeApi;
